// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__1b6ib","tab":"Tabs_tab__3T4sJ","tabActive":"Tabs_tabActive__3ndGS"};